<script lang="ts">
	interface Props {
		className?: string;
		hexColor?: string;
		rotate?: string;
	}

	let { className = '', hexColor = '', rotate = '' }: Props = $props();
</script>

<div
	class="w-[7px] h-[7px] flex-none {rotate} {hexColor ? '' : 'bg-primary'} {className}"
	style={hexColor ? `background-color: ${hexColor}` : undefined}
></div>
